<template>
  <el-dialog
    :title="title"
    width="80%"
    custom-class="roll-dialog"
    :visible="true"
    :destroy-on-close="true"
    :before-close="handleClose"
    lock-scroll
  >
    <template v-if="type === 'buy'">
      <h2 class="dialog-center">软件购买须知</h2>
      <div text-indent>
        在订购使用任何第三方产品开发者（以下简称“服务商”）基于旺店通开放平台开发并通过旺店通服务市场（以下可简称“服务市场”）订购产品之前，请
        您仔细阅读下述须知条款。
        <br>
        一旦您点击确认本协议，即表示您已接受了以下所述的条款和条件，同意受本协议约束。如果您不同意接受全部的条款和条件，那么您将无法订购使用在旺
        店通服务市场发布的服务商产品。
      </div>
      <h3>一、 定义</h3>
      1 旺店通：旺店通服务市场的开发者及所有者。
      <br>
      2 旺店通服务市场/服务市场：指旺店通提供的供交易双方或多方开展产品宣传、交易活动以及其他技术服务的服务平台。
      <br>
      3 服务商：在旺店通服务市场中注册并宣传、销售产品或服务的的第三方产品开发者。
      <br>
      4 用户：持有合法账户并使用旺店通服务平台的自然人、法人及非法人组织。
      <br>
      5 产品：指服务商在旺店通服务平台中宣传或销售的产品或提供的服务。
      <br>

      <h3>二、 产品订购方式</h3>
      1 用户需凭其合法取得的旺店通用户名和密码访问旺店通服务市场，并订购使用服务商提供的产品。对于用户通过其他手段登录、使用所造成的后果，旺店通将不承担任何责任。
      <br>
      2 服务商仅根据用户登录名和密码来确认使用服务商产品的用户身份。用户应妥善保管用户登录名及密码，并对其使用及其遗失自行承担责任。

      <h3>三、 产品在线交易须知</h3>
      <div class="dialog-weight">
        1 用户理解并同意，旺店通仅提供互联网交易平台，对于产品和交易对象的选择和交易的内容，应由用户自行判断，注意交易风险且审慎交易。
        <br>
        2 用户理解并同意，交易是其与服务商自行达成的，其在订购服务商提供的产品时，应自行与服务商签署相应的《产品授权使用协议》，并严格按照协议的约定履行。
        <br>
        3 用户理解并同意，服务商产品的唯一责任人为服务商。旺店通服务平台仅为服务商产品的订购或使用的地点或途径，旺店通无须就服务商产品向用户承担任何责任。
      </div>
      4 为保障交易安全，用户支付的产品授权费用将直接打入旺店通账户并由旺店通根据与服务商签订的合作协议约定的结算方式，分期或分阶段与服务商进行结算。
      <span class="dialog-weight">用户支付费用后如需开具相应金额的发票，应由用户自行向服务商提出申请并由服务商负责开具。</span>因交易而产生的税费应由用户和服务商自行承担。
      <br>
      <div class="dialog-weight">
        5 旺店通服务市场仅作为服务商和用户物色交易对象，就产品的交易进行协商，以获取或使用各类产品的地点。旺店通代收代付交易款项等行为并不
        意味着旺店通成为交易的参与者，旺店通不对服务商和用户行为的合法性、有效性及产品的真实性、合法性和有效性作任何明示和默示的担保。
        <br>
        6 旺店通对产品可能存在的缺陷或错误不提供任何保证或担保，对用户使用产品可能产生的损失也不承担违约或任何其他责任。
      </div>
      7 用户要求退款的，服务商可能根据收费标准或退款规定等原因拒绝退款，届时用户无权直接要求旺店通进行退款。
      <br>
      <span class="dialog-weight">8 对于服务商提供的产品，由于网上交易平台的特殊性，且旺店通并不控制该等产品，用户承认并同意，旺店通并不对该等产品的可用性负责，不事先审查该等产品，且不认可该等产品所涉及的任何内容、宣传或其他材
      料，也不对其等负责或承担任何责任。用户进一步承认和同意，对于任何因使用或信赖类产品中获取的内容、宣传或其他材料而造成（或声称造成）的任何直接或间接损失，旺店通均不承担责任。</span>
      <h3>四、 协议修改</h3>
      用户认可，旺店通有权根据国家相关法律法规、政策及平台运营情况，对本协议予以修改，如乙方不接受调整，用户有权停止使用旺店通服务平台
      提供的服务，如用户在相关调整生效后仍继续使用旺店通平台服务的，视为乙方接受调整后的协议。
      <h3>五、 法律及争议解决</h3>
      本协议适用中华人民共和国大陆地区法律。因双方就本协议的签订、履行或解释发生争议，任何一方均可向北京仲裁委员会提起仲裁。
      <br>
      <br>
      <div class="dialog-weight">
        您已阅读完毕本协议全部内容，若您点击确认，即视为接受并同意本协议的条款和条件。
        <br>
        （以下无正文）
      </div>
    </template>
    <template v-if="type === 'privacy'">
      <h2 class="dialog-center">旺店通服务平台隐私政策</h2>
      <div>
        发布时间：2023 年 06 月 12 日
        <br>
        生效时间：2023 年 06 月 12 日
      </div>
      <div>
        <br>
        尊敬的用户：
        <br>
        <br>
        您的信任对【慧策集团】（以下简称“我们”）非常重要，我们深知用户隐私信息对您的重要性，本《旺店通服务平台隐私政策》（以下简称“《隐私协议》”）
        将向您说明旺店通服务市场会如何收集、使用、储存您的个人信息，请您在使用旺店通服务市场前请务必认真阅读、理解并同意本《隐私政策》。
        <br>
        尊敬的用户：
        <br>
        一、我们收集哪些类型的信息
        <br>
        二、我们如何保护这些信息
        <br>
        三、我们如何使用这些信息
        <br>
        四、信息共享和对外提供
        <br>
        五、如何联系我们
        <br>
        六、其他
      </div>
      <h3>一、我们收集哪些类型的信息</h3>
      您在使用我们的产品，或者我们向您提供服务时，我们会收集下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。我们可能收集如下信息：
      <br>
      1 您向我们提供的信息您在使用我们服务时可能会向我们提供如下信息：您在注册账户或使用我们的服务时，向我们提供的信息，例如<span class="dialog-weight">您的手机号、公司名称、用户名、收件
      地址</span>等信息；若您不提供这类信息，您将无法正常使用我们的服务。
      <br>
      2 我们获取的您的信息当您使用软件时，为向您提供产品及服务，维护我们服务的正常运行，改进及优化我们的服务体验以及保障您的帐号安全，我们会收集您下述信息：
      <br>
      2.1 设备或软件信息：我们会收集您设备或软件专用的信息（例如您的硬件型号、操作系统版本、唯一设备标识符以及包括电话号码在内的移动网络信息）。
      <br>
      2.2 日志信息：当您使用我们的服务或查看由我们提供的内容时，我们可能会自动收集某些信息并存储到服务器日志中。此类信息包括：您对我们服务的详细使用情况，例如您的新增、查询内容；
      <br>
      2.3 IP 地址：设备事件信息，例如崩溃、系统活动、硬件设置、浏览器类型、浏览器语言、您提出请求的日期和时间以及引荐网址。可唯一标识您的浏览器或帐户的 Cookie。
      <br>
      2.4 唯一应用程序编号：某些服务包含唯一应用程序编号。当您安装或卸载相关服务或当这些服务定期与我们的服务器通信（例如对软件进行自动更新）时，系统会将此编号以及与安装相关的信息（例如操作系统类型和应用程序版本号）发送给我们。
      <br>
      2.5 为提供服务收集使用的权限：相机：扫描一维码或二维码用于识别货品信息。
      <h3>二、我们如何保护这些信息</h3>
      我们将采取以下措施，努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露：
      <br>
      1 建设独立的安全数据中心，保障数据安全，防止您的信息泄露、损毁、丢失；
      <br>
      2 通过有效的安全技术，确保系统内部及第三方传输中的信息保密；
      <br>
      3 通过严格的安全合规管理，杜绝信息的不当使用。
      <br>
      4 其他为保障用户信息安全而采取的合理措施。
      <h3>三、我们如何使用这些信息</h3>
      我们严格遵守法律法规的规定及与用户的约定，将收集的信息按照本隐私政策的规定用于以下用途。
      <br>
      1 提供、维护及开发产品服务：我们会利用收集的信息来提供和优化改进产品服务
      <br>
      2 安全保障：为保障您的数据安全，我们会利用相关信息协助提升产品的安全性和可靠性，包括检测、防范和应对可能危害产品、我们的用户的欺诈行为、滥用行为、非法行为、安全风险和技术问题等；
      <br>
      3 与您沟通：在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份等用途，确保我们向您提供的产品和服务的安全性；
      <br>
      4 帮助我们完善现有服务，开发新的功能以为您提供更好的服务；
      <br>
      5 使我们更加了解您的个性化需求，为您提供定制化服务内容，例如某些功能使用频率比较高，操作路径比较长
      <br>
      6 根据相关法律法规以及国家标准，在以下情况下我们可能会收集、使用您的个人信息而无需征求您的授权同意：
      <br>
      6.1 与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公众知情等重大公共利益直接相关的；
      <br>
      6.2 与犯罪侦查、起诉、审判和判决执行等直接相关的；
      <br>
      6.3 根据您要求签订和履行合同所必需的；
      <br>
      6.4 用于维护所提供的产品或服务的安全稳定运行所必需的。如发现、处置 产品或服务的故障；
      <br>
      6.5 法律法规规定的其他情形。
      <h3>四、信息共享和对外提供</h3>
      目前，我们不会将您的个人信息用于个性化推荐或广告用途。如我们使用您 的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们
      将在使用您的个人信息前，通过页面提示、交互流程、网站公告等方式另行向您 告知并征得您的明示同意。我们不会共享或转让您的个人信息至第三方，但以下情况除外：
      <br>
      1 获取您的明确同意：经您事先同意，我们可能与第三方分享您的个人信息；
      <br>
      2 为实现外部处理的目的，我们可能会与其他第三方合作伙伴（第三方服务 供应商、承包商、代理、应用开发者等）分享您的个人信息，让他们按照 我们的说明、隐私政策以及其他相关的保密和安全措施来为我们处理上述
      信息，并用于向您提供我们的服务，实现“我们如何使用信息”部分所述 目的。如我们与上述关联公司或第三方分享您的信息，我们将会采用加密、 匿名化处理等手段保障您的信息安全。
      <br>
      3 我们不会对外公开披露所收集的个人信息，如必须公开披露时，我们会向 您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并
      征得您的明示同意。需要特别说明的是，对最终用户相关信息如何在其加 入的企业用户工作平台中披露或对外共享，由企业用户决定并管理。
      <br>
      4 我们可能基于法律要求或相关部门的执法要求披露您的个人信息。
      <br>
      5 在不透露单个用户隐私资料的前提下，我们公司有权对整个用户数据库进行推演、计算、分析、梳理、挖掘应用，并在此基础上对用户数据库进行
      商业上的利用。我们保证不对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在我们处的非公开内容。如我们与任何第三方分享您的信息，我们将努力确保该等第三方在使用您
      的信息时遵守本《隐私政策》及我们要求其遵守的其他适当的保密和安全措施。
      <h3>五、其他</h3>
      1. 如就本《隐私政策》的解释或执行发生争议，任意一方可向北京仲裁委员会仲裁解决。本《隐私政策》的成立、生效、履行、解释及纠纷解决，
      适用中华人民共和国大陆地区法律。
      <br>
      2. 如本《隐私政策》中的任何条款与已发布的用户协议存在约定不一致或相互冲突的，以本《隐私政策》条款为准。
      <h3>六、如何联系我们</h3>
      如对本《隐私政策》或相关事宜有任何疑问、意见或建议，您可通过我们提供的各种联系方式与我们联系。
      <br>
      公司名称：慧策集团
      <br>
      常用办公地址：北京市西城区西直门外大街 1 号西环广场 T1 座 7 层
      <br>
      联系方式：400-010-1039
    </template>
    <template v-if>

    </template>
  </el-dialog>
</template>
<script>

export default {
  props: {
    type: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    handleClose() {
      this.$emit("closeDialog", false);
    },
  }
};
</script>
<style lang="scss">
.roll-dialog .el-dialog__body {
  overflow-y: auto;
  height: calc(100vh - 35vh);
  color: #333;
  line-height: 30px;
}
.dialog-center {
  text-align: center;
}

.dialog-weight {
  font-weight: bolder;
}
</style>
